const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/area_cliente/chamados/adicionar',
                component: () => import('../views/Adicionar')
            }
        ]
    },
    // GCK-20834: a central de chamados usa o shell próprio do portal (PortalLayout)
    {
        path: '/area_cliente/chamados',
        component: () => import('../views/Listar')
    },
    // GCK-20840: o detalhe do chamado usa o shell próprio do portal (PortalLayout)
    {
        path: '/area_cliente/chamados/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
